module.exports = __webpack_public_path__ + "img/stakeOut.9b5b36ba.png";